import { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useUser } from "../../user_context";
import './css/js_layout.css';




const NAV_ITEMS = [
  { 
    id: "dashboard",
    path: "/dashboard", 
    label: "Dashboard",
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="3" width="7" height="9" />
        <rect x="14" y="3" width="7" height="5" />
        <rect x="14" y="12" width="7" height="9" />
        <rect x="3" y="16" width="7" height="5" />
      </svg>
    )
  },
  { 
    id: "jobs", 
    path: "/jobs", 
    label: "Browse Jobs",
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
        <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
      </svg>
    )
  },
  { 
    id: "search",
    path: "/search", 
    label: "Find Employers",
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="11" cy="11" r="8" />
        <line x1="21" y1="21" x2="16.65" y2="16.65" />
        <path d="M11 7a4 4 0 0 0-4 4" />
      </svg>
    )
  },
  { 
    id: "applications", 
    path: "/applications", 
    label: "My Applications",
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <polyline points="14 2 14 8 20 8" />
        <line x1="16" y1="13" x2="8" y2="13" />
        <line x1="16" y1="17" x2="8" y2="17" />
        <polyline points="10 9 9 9 8 9" />
      </svg>
    )
  },
  { 
    id: "saved", 
    path: "/saved-jobs", 
    label: "Saved Jobs",
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
      </svg>
    )
  },
  { 
    id: "profile",
    path: "/profile", 
    label: "My Profile", 
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
        <circle cx="12" cy="7" r="4" />
      </svg>
    )
  },
  { 
    id: "marketplace",
    path: "/marketplace", 
    label: "Market Place", 
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
        <line x1="3" y1="6" x2="21" y2="6" />
        <path d="M16 10a4 4 0 0 1-8 0" />
      </svg>
    )
  }
  /* UNCOMMENT ANY OF THESE WHEN READY:
  ,
  { 
    id: "portfolio",    
    path: "/portfolio",           
    label: "Portfolio",
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12 6.477 22 12 22z" />
        <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
        <path d="M2 12h20" />
      </svg>
    )
  },
  { 
    id: "messages",     
    path: "/messages",            
    label: "Messages",          
    badge: "2",
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
        <polyline points="22,6 12,13 2,6" />
      </svg>
    )
  },
  { 
    id: "settings",     
    path: "/settings",            
    label: "Settings",
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="3" />
        <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
      </svg>
    )
  }
  */
];

const BOTTOM_NAV = [
  { id: "dashboard",    path: "/dashboard", icon: "◈", label: "Home" },
  { id: "jobs",         path: "/jobs",                icon: "✦", label: "Jobs" },
  { id: "search",       path: "/search",        icon: "🔍",   label: "Employers" },
  { id: "applications", path: "/applications",        icon: "◻", label: "Applications" },
  // { id: "messages",     path: "/messages",            icon: "✉", label: "Messages", badge: "2" },
  { id: "profile",      path: "/profile",             icon: "◯", label: "Profile" },
];

export default function JSLayout({ children, title, titleEm, topbarRight }) {
  const navigate   = useNavigate();
  const location   = useLocation();
  const [open, setOpen] = useState(false);
  const { userData, loading } = useUser();
  const active = (path) => location.pathname === path;


  // console.log("User Data in Layout:", userData);
  useEffect(() => {
    if (!loading && !userData) {
      navigate("/signin", { replace: true });
    }
    const token = localStorage.getItem("token");
    if (!token && userData) {
      window.location.href = "/signin";
    }
  }, [userData, loading, navigate]);

  if (loading) {
    return (
      <div className="layout-loading-screen">
        <div className="spinner">Loading your profile...</div>
      </div>
    );
  }

  if (!userData) return null;

  return (
    <div className="bl-layout-root">
      {/* overlay */}
      <div className={`bl-overlay${open ? " open" : ""}`} onClick={() => setOpen(false)} />

      {/* sidebar */}
      <aside className={`bl-sidebar${open ? " open" : ""}`}>
        <Link to="/" className="bl-logo">Rembo<span>List</span></Link>

        <div className="bl-nav-label">Main</div>
        {NAV_ITEMS.slice(0, 7).map(n => (
          <Link key={n.id} to={n.path} className={`bl-nav-item${active(n.path) ? " active" : ""}`} onClick={() => setOpen(false)}>
            <span className="bl-nav-icon">{n.icon}</span>
            {n.label}
            {n.badge && <span className="bl-nav-badge">{n.badge}</span>}
          </Link>
        ))}

        {userData?.isAdmin && (
          <>
            <div className="bl-nav-label">Admin</div>
            <Link
              to="/admin/metrics"
              className={`bl-nav-item${active("/admin/metrics") ? " active" : ""}`}
              onClick={() => setOpen(false)}
            >
              <span className="bl-nav-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M12 2l8 4v6c0 5-3.4 8.4-8 10-4.6-1.6-8-5-8-10V6z" />
                  <path d="M9 12l2 2 4-4" />
                </svg>
              </span>
              Administration
            </Link>
          </>
        )}

        {/* <div className="bl-nav-label">Profile</div>
        {NAV_ITEMS.slice(4, 7).map(n => (
          <Link key={n.id} to={n.path} className={`bl-nav-item${active(n.path) ? " active" : ""}`} onClick={() => setOpen(false)}>
            <span className="bl-nav-icon">{n.icon}</span>
            {n.label}
            {n.badge && <span className="bl-nav-badge">{n.badge}</span>}
          </Link>
        ))} */}

        {/* <div className="bl-nav-label">Account</div>
        {NAV_ITEMS.slice(7).map(n => (
          <Link key={n.id} to={n.path} className={`bl-nav-item${active(n.path) ? " active" : ""}`} onClick={() => setOpen(false)}>
            <span className="bl-nav-icon">{n.icon}</span>
            {n.label}
          </Link>
        ))} */}

        <div className="bl-sidebar-footer">
          <div className="bl-user-chip">
            <div className="bl-avatar">{loading ? ".." :userData?.initials || "--"}</div>
            <div>
              <div className="bl-user-name">{loading ? ".." :userData?.displayName || "User"}</div>
              <div className="bl-user-role">{loading ? ".." :userData?.specialisation || "--"}</div>
            </div>
          </div>
          <button className="bl-signout" onClick={() => navigate("/signin")}>↩ Sign out</button>
        </div>
      </aside>

      {/* topbar */}
      <header className="bl-topbar">
        <div className="bl-topbar-left">
          <button className="bl-hamburger" onClick={() => setOpen(true)} aria-label="Menu">☰</button>
          <div className="bl-topbar-title">{title}{titleEm && <> — <em>{titleEm}</em></>}</div>
        </div>
        <div className="bl-topbar-right">
          {topbarRight}
          {/* <button className="bl-notif-btn">🔔<span className="bl-notif-dot" /></button> */}
          <div className="bl-avatar">{loading ? ".." :userData?.initials || "--"}</div>
        </div>
      </header>

      {/* page content */}
      <main className="bl-main">{children}</main>

      {/* bottom nav */}
      <nav className="bl-bottom-nav">
        <div className="bl-bottom-nav-inner">
          {BOTTOM_NAV.map(n => (
            <Link key={n.id} to={n.path} className={`bl-bn-item${active(n.path) ? " active" : ""}`}>
              {n.badge && <span className="bl-bn-badge">{n.badge}</span>}
              <span className="bl-bn-icon">{n.icon}</span>
              <span className="bl-bn-label">{n.label}</span>
            </Link>
          ))}
        </div>
      </nav>
    </div>
  );
}
